import { render, staticRenderFns } from "./fixed_asset_detail.vue?vue&type=template&id=91a549c4&scoped=true"
import script from "./fixed_asset_detail.vue?vue&type=script&lang=js"
export * from "./fixed_asset_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a549c4",
  null
  
)

export default component.exports